import React, { useCallback } from 'react';
import { useRequest } from 'ahooks';
import Panel from '@/components/Panel';
import { Area } from '@ant-design/charts';
import { GetParkingIndex } from '@/services/api';
import { Spin } from 'antd'
import ImgSource from '@/assets/img/jingying/shoururiqishi@2x.png'
import { chartDataFill } from '@/utils/chart'

export interface ParkingDailyIncomeProps {
  areaCode?: string;
}

const map = {
  oneHourArrive: '一小时到达率',
  parkTimes: '停车时长',
  turnover: '周转率',
} as const;

interface ChartData {
  time: string;
  oneHourArrive: number;
  parkTimes: number;
  turnover: number;
}

const ParkingDailyIncome: React.FC<ParkingDailyIncomeProps> = ({ areaCode }) => {
  const { data = [], loading, error } = useRequest(useCallback(() => {
    return GetParkingIndex({ areaCode });
  }, [areaCode]), {
    formatResult: (res: { data: any[] }) => {
      return res.data.map((item: any) => ({
        ...item,
        time: (item.monthDay).split('-')[1] + '-' + (item.monthDay).split('-')[2]
      })) as ChartData[];
    },
    refreshDeps: [areaCode]
  })

  if (loading) {
    return (
      <Panel title="停车指数">
        <div className="fetch_container" style={{ height: 200 }}>
          <Spin />
        </div>
      </Panel>
    )
  }

  if (error) {
    return (
      <Panel title="停车指数">
        <div className="fetch_container" style={{ height: 200 }}>
          请求错误
        </div>
      </Panel>
    )
  }

  const transformedData = data.flatMap(item => 
    Object.entries(map).map(([key, name]) => ({
      time: item.time,
      type: name,
      value: item[key as keyof typeof map]
    }))
  );

  const config = {
    height: 200,
    padding: [20, 20, 23, 48],
    smooth: true,
    data: transformedData,
    xField: 'time',
    yField: 'value',
    seriesField: 'type',
    legend: {
      position: 'top',
      visible: false
    } as any,
    xAxis: {
      label: {
        style: {
          fill: '#fff'
        }
      },
      line: {
        style: {
          stroke: '#12708D'
        }
      },
      range:[0,1],
      tickLine: null
    },
    yAxis: {
      label: {
        style: {
          fill: '#fff'
        },
        formatter: (v: string) => `${v}`,
      },
      // line: {
      //   style: {
      //     stroke: '#12708D'
      //   }
      // },
      grid: {
        line: {
          style: {
            stroke: '#12708D',
            strokeOpacity: 0.4
          }
        }
      }
    },
    tooltip: {
      formatter: (datum: any) => {
        return {
          name: datum.type,
          value: datum.value
        }
      },
      showTitle: false
    },
    animation: {
      appear: {
        animation: 'path-in',
        duration: 3000
      },
      enter: {
        easing: 'easeLinear',
        duration: 3000,
        delay: 2000,
      }
    }
  };

  return (
    <Panel title="停车指数">
      {data?.length > 0 ? (
        <Area {...config} />
      ) : (
        <div className="fetch_container" style={{ height: 200 }}>
          暂无数据
        </div>
      )}
    </Panel>
  )
}

export default ParkingDailyIncome;